import { serverCall } from "../modules/ServerComms";

function createDiscount(payload, theCallback, theJWTToken) {
    const API_URL = `/api/coupon/create`;
    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getRetrieveDiscounts(queryParams, theCallback, theJWTToken) {
    let queryString = "?";

    for (const key in queryParams) {
        if (
            queryParams.hasOwnProperty(key) &&
            queryParams[key] !== null &&
            queryParams[key] !== undefined &&
            queryParams[key] !== ""
        ) {
            queryString += `${key}=${encodeURIComponent(queryParams[key])}&`;
        }
    }

    if (queryString.endsWith("&")) {
        queryString = queryString.slice(0, -1);
    }
    if (queryString === "?") {
        queryString = "";
    }

    const API_URL = `/api/coupon/coupons${queryString}`;

    serverCall(
        "GET",
        API_URL,
        null,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function updateDiscount(payload, theCallback, theJWTToken) {
    const API_URL = `/api/coupon/update`;
    serverCall(
        "POST",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function bulkDeleteDiscounts(payload, theCallback, theJWTToken) {
    const API_URL = `/api/coupon/bulkDelete`;
    serverCall(
        "DELETE",
        API_URL,
        payload,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

function getDiscountCounts(theCallback, theJWTToken) {
    const API_URL = `/api/coupon/statusCount`;
    serverCall(
        "GET",
        API_URL,
        null,
        function (resStatus, resJson) {
            let responseString;
            if (resStatus == "200" || resStatus == 200) {
                if (resJson.message) {
                    responseString = resJson.message;
                }
                return theCallback(resStatus, responseString, resJson);
            } else {
                return theCallback(resStatus, resJson.message, false);
            }
        },
        theJWTToken,
    );
}

export {
    createDiscount,
    getRetrieveDiscounts,
    updateDiscount,
    bulkDeleteDiscounts,
    getDiscountCounts,
};
